import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { Subject } from 'rxjs';

@Component({
  selector: 'status-dialog',
  templateUrl: 'status-dialog.html'
})
export class StatusDialogComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  form: FormGroup;
  program_id: string;
  patient: any;
  status: any;
  substatus: any;
  user: any;
  statuses: any[] = [];
  substatuses: any[]= [];

  constructor(
    private db: DatabaseProvider,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<StatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.patient = data.patient;
    this.program_id = data.program_id;
    if (data.patient.status)  {
      this.status = data.patient.status;
      this.substatus = data.patient.substatus;
    }
    this.db
    .getAdminSettings(this.program_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((settings) => {
      this.statuses = settings[0]['statuses'];
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      status: [null, Validators.required],
      substatus: [null],
      date: [null],
      therapy_status: [null],
      therapy_substatus: [null],
      therapy_type: [null],
      notes: [null]
    })
    this.form.controls['date'].setValue(new Date());
  }

  ngOnDestroy() {
    console.log('Leave status dialog and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onStatusChange(ev)  {
    const substatus = this.statuses.filter(item => item.status === ev.value);
    this.substatuses = substatus[0]['substatus'];
  }

  submit() {
    let statuschange = this.form.value;
    this.dialogRef.close(statuschange);
  }
}



// WEBPACK FOOTER //
// ./src/components/status-dialog/status-dialog.ts